<script>
import DesktopLayout from '@layouts/desktop.vue';
import MobileLayout from '@layouts/mobile.vue';
import { authComputed, nutritionMethods } from '@state/helpers';
import { breakpointsMixin } from '@mixins/breakpointsMixin';

export default {
  page: {
    title: 'Nutrition',
    meta: [{ name: 'description', content: 'The Nutrition page.' }],
  },
  components: {
    DesktopLayout,
    MobileLayout,
  },
  mixins: [breakpointsMixin],
  data() {
    return {};
  },
  mounted() {
    this.setIsNutritionUpdated(true);
  },
  computed: {
    ...authComputed,
    embedUrl() {
      if (this.userProfile && this.userProfile.menud_auth_token) {
        return process.env.VUE_APP_MENUD_EMBED_URL + '?authToken=' + this.userProfile.menud_auth_token;
      } else {
        return '';
      }
    },
  },
  methods: {
    ...nutritionMethods,
    back() {
      document.getElementById('iframe').contentWindow.history.back(-1);
    },
  },
};
</script>

<template>
  <div>
    <DesktopLayout v-if="isDesktopView">
      <iframe :src="embedUrl" :style="{ paddingTop: '6rem' }" id="iframe" class="embedFrame"></iframe>
    </DesktopLayout>

    <MobileLayout v-if="!isDesktopView">
      <iframe :src="embedUrl" id="iframe" class="embedFrame mobile"></iframe>
    </MobileLayout>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.embedFrame {
  border: unset;
  box-shadow: unset;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  min-height: 100vh;
  width: 100%;
  &.mobile {
    min-height: calc(100vh - 7.8rem);
  }
}
</style>
